import React from 'react'
import PropTypes from 'prop-types'

import NoSearchResults from './NoSearchResults'
import NoProducts from './NoProducts'

function EmptyContent({ filtersUsed }) {
  return (
    <div className="empty-content u-text-center">
      {filtersUsed ? <NoSearchResults /> : <NoProducts />}
    </div>
  )
}

EmptyContent.propTypes = {
  filtersUsed: PropTypes.bool.isRequired,
}

export default EmptyContent
